import React from 'react';

export type HistoryPage = {
  heading: string;
  onClick?: () => void;
  to?: string;
} & ({
  onClick: () => void;
} | {
  to: string;
});

export interface HistoryPageContextContent {
  historyPages?: HistoryPage[];
  setHistoryPages?: (historyPages: HistoryPage[]) => void;
}

export default React.createContext<HistoryPageContextContent>({
  historyPages: undefined,
  setHistoryPages: undefined,
});
